import { useState } from 'react';

import Icon from './Icon.jsx';
import { resendVerification } from '../lib/accountClient.js';

/**
 * "Confirm your email."
 *
 * Deliberately a strip rather than a wall. Blocking an unconfirmed account out
 * of the app would mean that a bounced email, a full inbox or a spam filter
 * locks somebody out of work they have already done — and on the day the mail
 * provider has an outage, out of everybody. The address is worth confirming;
 * it is not worth holding somebody's streak hostage over.
 *
 * Dismissed per visit, not permanently: it should be easy to get out of the way
 * and hard to forget about entirely.
 */
export default function ConfirmBanner({ email, onDismiss }) {
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);

  return (
    <div className="confirm" role="status">
      <Icon name="dove" size={17} className="confirm__mark" />
      <p className="confirm__text">
        {sent ? (
          <>
            <strong>Link sent.</strong> Check {email} — and the spam folder, which is where a
            first email often lands.
          </>
        ) : (
          <>
            <strong>Confirm your email.</strong> We sent a link to {email}. It keeps the account
            yours if you ever forget the password.
          </>
        )}
      </p>
      {!sent && (
        <button
          type="button"
          className="confirm__action"
          disabled={sending}
          onClick={async () => {
            setSending(true);
            await resendVerification();
            // Shown regardless of the answer: the server deliberately will not
            // say whether it sent one, and a failure message here would be a
            // guess presented as a fact.
            setSent(true);
            setSending(false);
          }}
        >
          {sending ? 'Sending…' : 'Send again'}
        </button>
      )}
      <button type="button" className="confirm__close" onClick={onDismiss} aria-label="Dismiss">
        <Icon name="close" size={13} />
      </button>
    </div>
  );
}
